import { fetcher } from "helpers/fetcher";

import { TAddDepartmenttReq, TAddDepartmenttRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const addDepartment = async (payload: TAddDepartmenttReq) => {
  return await fetcher<TAddDepartmenttRes, TAddDepartmenttReq>(
    ENDPOINT.USER.ADD_DEPARTMENT,
    {
      data: payload,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.USER.ADD_DEPARTMENT.version,
      },
    }
  );
};

export const mutationAddDepartment = async (payload: TAddDepartmenttReq) => {
  return (await addDepartment(payload)).data.message;
};

mutationAddDepartment._key = (payload: TAddDepartmenttReq) => [
  ENDPOINT.USER.ADD_DEPARTMENT.url,
  payload,
];
